(function () {
    'use strict';

    angular.module("imApp").factory("timeInOutsService", ['$ihttp', function ($ihttp) {
        let service = {
            listTimeInOuts: function (parms) {
                return $ihttp.post({
                    method: 147,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
